import { render, staticRenderFns } from "./AssetsMaterialsShow.vue?vue&type=template&id=30b9e94a&"
import script from "./AssetsMaterialsShow.vue?vue&type=script&lang=js&"
export * from "./AssetsMaterialsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports